import React, { useContext } from 'react'
import log from 'loglevel'
import { BasicDropdownMenuItem } from 'src/components/Reusable/BasicDropdown/BasicDropdown.styles'
import { useAudit } from '../../../../components/async/model/audit'
import { Spinner, ThrobberContext } from '../../../../Throbber'
import { useDownloadControlsReport } from '../../../../components/async/model/control'
import { showInfoToast } from '../../../../Utils/helpers/toast'

export const ControlsCSV = (props: {
  eventKey: string
  auditId: string
}): JSX.Element => {
  const { eventKey, auditId } = props
  const { data: audit } = useAudit(auditId)
  const { setThrobberState } = useContext(ThrobberContext)
  const downloadControlsReport = useDownloadControlsReport(auditId)

  const onDownload = async (e: React.MouseEvent) => {
    try {
      e.preventDefault()
      setThrobberState({
        isShown: true,
        Display: <Spinner color="primary" size="xl" />,
      })
      await downloadControlsReport()
    } catch (err) {
      showInfoToast(
        'Sorry, we could not download your Controls Report properly - Please try again later.',
      )
      log.error('Error downloading Controls CSV: ', err)
    } finally {
      setThrobberState({
        isShown: false,
        Display: <></>,
      })
    }
  }

  return !audit ? (
    <></>
  ) : (
    <BasicDropdownMenuItem eventKey={eventKey} onClick={onDownload}>
      Controls (.csv)
    </BasicDropdownMenuItem>
  )
}
